import _ from "lodash";
import ShimmerScreen from "../../../components/Layouts/ShimmerScreen";
import { clickStreamUser, SessionKeys } from "../../../utils/AppUtils";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { dynamicBanner } from "../../../redux/Cart/actions";
import moment from "moment";
import Loader from "../../../components/Loader/Loader";
import { getActiveHeader } from "../../../redux/home/actions";

const HomeBanner = () => {
  const dynamicBannerInfo = useSelector((state) => state.carts.dynamicBanner);
  const dispatch = useDispatch();
  const [bannerData, setBannerData] = useState({});
  const [bannerBrokerData, setBannerBrokerData] = useState({});
  const userRole = useSelector((state) => state.user.role);
  const [isLoading, setIsLoading] = useState(false)
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector(state => state.auth.authBroker)

  useEffect(() => {
    dispatch(getActiveHeader("home"))
    setIsLoading(true)
    dispatch(
      dynamicBanner({
          module: "splash-banner",
          broker: true,
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          }
      })
    );
  }, [dispatch]);

  useEffect(() => {
    console.log("merge data", dynamicBannerInfo);
    if (!_.isEmpty(dynamicBannerInfo)) {
       setTimeout(() => {
        setIsLoading(false)
      }, 1000);
      
        if (dynamicBannerInfo.status === "success") {
          let bannerData = _.isArray(dynamicBannerInfo.payload.data)
            ? dynamicBannerInfo.payload.data
            : [];
          setBannerData(bannerData);
        }
    }
  }, [dynamicBannerInfo]);

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    arrows: false,
    autoplaySpeed: 5000,
    infinite: true,
  };

  return (
    <>
     <Loader start={isLoading} />
      {userRole === "instructor" || userRole === "host" ? (
        ""
      ) : (
        <Slider {...settings}>
          {bannerData.length > 0 ? (
            bannerData.map((m, index) => {
              return (
                <section id="heroBanner" className="banner text-white" aria-label="Upcoming webinar" key={index}>
                  <img src={m.thumbnail} alt="Upcoming webinar banner" className="img-fluid" />
                  <div className="banner-content">

                    {m?.banner_title_visibility === "1" && <h2 className="h2 mb-0">
                      {m.banner_title}
                    </h2>}
                    <p className="m-0">
                      {/* {moment(m.event_start_date, "DD/MM/YYYY").format("MMM Do")} */}
                      {m?.sub_title}
                      </p>

                    <a
                      href={m.button_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {(m.button_text === undefined || _.isEmpty(m.button_text)) ? "" : <button
                        type="button"
                        className="custom-btn"
                        onClick={() => {
                          clickStreamUser("more-info-button-clicked", {
                            url: m.button_url,
                            userId: authBroker?.payload?.user.user_id,
                          });
                        }
                        }
                      >
                        {m.button_text}

                      </button>}
                    </a>
                  </div>
                </section>

              );
            })
          ) : (
            <>
              {/* <div className="nobannerimage"></div>
              <div className="container">
                <p
                  className="my-cart-texts"
                  style={{ fontSize: "18px", fontFamily: "Inter" }}
                ></p>
              </div> */}
              {
                isLoading ?
                  <div className="nobannerimage ">
                    <ShimmerScreen
                      case={'rect'}
                      width={'100%'}
                      height={'100%'}
                    />
                  </div> :
                  <div className="nobannerimage loading-stop">
                    <p
                      className="my-cart-texts"
                      style={{ fontSize: "18px"}}
                    ></p>
                  </div>
              }
            </>
          )}
        </Slider>
      )}
    </>
  );
};

export default HomeBanner;